__turbopack_context__.v({
  "arrow": "styles-module-scss-module__ZaeFNa__arrow",
  "content": "styles-module-scss-module__ZaeFNa__content",
  "description": "styles-module-scss-module__ZaeFNa__description",
  "dots": "styles-module-scss-module__ZaeFNa__dots",
  "icon": "styles-module-scss-module__ZaeFNa__icon",
  "item": "styles-module-scss-module__ZaeFNa__item",
  "line": "styles-module-scss-module__ZaeFNa__line",
  "listWrapper": "styles-module-scss-module__ZaeFNa__listWrapper",
  "title": "styles-module-scss-module__ZaeFNa__title",
  "wrapper": "styles-module-scss-module__ZaeFNa__wrapper",
});
